// store/modules/snackbar.js
export default {
  namespaced: true,
  state: {
    show: false,
    message: '',
    color: 'success', // success, error, info, warning
    timeout: 3000
  },
  mutations: {
    SHOW_SNACKBAR(state, payload) {
      state.message = payload.message
      state.color = payload.color || 'success'
      state.timeout = payload.timeout || 3000
      state.show = true
      setTimeout(() => {
        state.show = false
      }, payload.timeout || 3000)
    },
    HIDE_SNACKBAR(state) {
      state.show = false
    }
  },
  actions: {
    trigger({ commit }, payload) {
      commit('SHOW_SNACKBAR', payload)
    }
  }
}